<template>
  <div>
    <v-card flat class="rounded-lg pa-6">
      <div>
        <title-page
          title="Documentation Internship"
          :back="true"
          colorIconBack="#006341"
        />
      </div>
      <div class="mt-2">
        <v-card
          class="pa-2 rounded-lg"
          outlined
          v-if="dataSet && dataSet.description && !loading"
        >
          {{ dataSet.description ? dataSet.description : "No description yet" }}
        </v-card>
        <v-skeleton-loader
          class="mt-2"
          v-if="loading"
          type="image"
        ></v-skeleton-loader>
      </div>
    </v-card>
    <v-card flat class="rounded-lg pa-6 mt-6">
      <v-row>
        <v-col cols="6">
          <h4>Internship Place</h4>
          <v-card
            class="pa-2 rounded-lg mt-3"
            outlined
            v-if="dataSet && !loading"
          >
            {{ dataSet.destination }}
          </v-card>
          <v-skeleton-loader
            class="mt-2"
            v-if="loading"
            type="text"
          ></v-skeleton-loader>
        </v-col>
        <v-col cols="6"> </v-col>
        <v-col cols="6">
          <h4>Status Internship</h4>
          <v-card
            class="pa-2 rounded-lg mt-3"
            outlined
            v-if="dataSet && !loading"
          >
            {{ dataSet.proposal_status == "aktif" ? "Active" : "Done" }}
          </v-card>
          <v-skeleton-loader
            class="mt-2"
            v-if="loading"
            type="text"
          ></v-skeleton-loader>
        </v-col>
        <v-col cols="6"> </v-col>
        <v-col cols="6">
          <div style="height: 30px">
            <h4>Duration</h4>
          </div>
          <h6>Start</h6>
          <v-card
            class="pa-2 rounded-lg mt-1"
            outlined
            v-if="dataSet && !loading"
          >
            {{ $date(dataSet.durasi_start).format("dddd, DD MMMM YYYY") }}
          </v-card>
          <v-skeleton-loader
            class="mt-2"
            v-if="loading"
            type="text"
          ></v-skeleton-loader>
        </v-col>
        <v-col cols="6">
          <div style="height: 30px"></div>
          <h6>End</h6>
          <v-card
            class="pa-2 rounded-lg mt-1"
            outlined
            v-if="dataSet && !loading"
          >
            {{ $date(dataSet.durasi_end).format("dddd, DD MMMM YYYY") }}
          </v-card>
          <v-skeleton-loader
            class="mt-2"
            v-if="loading"
            type="text"
          ></v-skeleton-loader>
        </v-col>
      </v-row>
      <div class="mt-2">
        <h4>Link for Documentation</h4>
        <h6 class="mt-2">Below are the link documentation</h6>
        <div
          class="mt-2 pa-4 d-flex align-center justify-center rounded-lg"
          style="
            width: 25%;
            border: 1px dashed #016443;
            background-color: rgba(0, 99, 65, 0.4);
          "
        >
          <a
            v-if="dataContent && !loading"
            target="blank"
            :href="dataContent.content"
            style="color: #006341"
            >Additional Link</a
          >
          <v-skeleton-loader
            class="mt-2"
            width="150px"
            v-if="loading"
            type="text"
          ></v-skeleton-loader>
        </div>
      </div>
    </v-card>
  </div>
</template>

<script>
import titlePage from "../../../components/atom/titlePage.vue";
export default {
  components: { titlePage },
  name: "dokumentasiInternshipScholar",
  data() {
    return {
      showPickerStart: false,
      showPickerEnd: false,
      optStatusInternship: [
        {
          name: "Active",
          val: "aktif",
        },
        {
          name: "Done",
          val: "selesai",
        },
      ],
      loading: true,
      dataSet: null,
      dataContent: null,
    };
  },
  async mounted() {
    this.fetchDataContent();
  },
  methods: {
    closeDateMenu(type) {
      if (type == "start") {
        this.showPickerStart = false;
        this.dataSet[0].durasi_start == ""
          ? this.date.format("dddd, MMMM Do YYYY")
          : "";
      } else {
        this.showPickerEnd = false;
        this.dataSet[0].durasi_end == ""
          ? this.date.format("dddd, MMMM Do YYYY")
          : "";
      }
    },
    fetchData() {
      this.loading = true;
      let data = {
        path: `proposal/internships?filter[scholar_intern_proposal.id]=${this.$route.params.idProposal}`,
      };
      this.$store
        .dispatch("user/getUser", data)
        .then((data) => {
          this.dataSet = data.data.length ? data.data[0] : null;
          this.loading = false;
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.loading = false;
        });
    },
    fetchDataContent() {
      this.loading = true;
      let data = {
        path: `proposal/internships/dokumen?id=${this.$route.params.idProposal}`,
      };
      this.$store
        .dispatch("user/getUser", data)
        .then((data) => {
          this.dataContent = data;
          this.fetchData();
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.loading = false;
        });
    },
  },
};
</script>

<style></style>
